var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({},'div',_vm.attrs,false),[_c('div',{staticClass:"data-state__icon"},[_c('ui-icon',{staticClass:"data-state__glyph",attrs:{"glyph":_vm.glyph}})],1),(_vm.hasLabel)?_c('div',{staticClass:"data-state__label"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }